import { AxiosResponse } from 'axios';

import { GetPartnersPayload } from '@/api/partners/request';
import { ClientService } from '@/types/api';
import { ImportProjectsListResponse } from './response';
import { ImportProjectItemDTO } from '@/features/import-projects/containers/dtos/types';

export class importProjectsApi {
	private prefix = 'import-projects';

	constructor(private readonly clientService: ClientService) {
		this.clientService = clientService;
	}

	public async getList({ filters, ...params }: GetPartnersPayload): Promise<AxiosResponse<ImportProjectsListResponse>> {
		return this.clientService.post(`${this.prefix}/list`, filters, {
			params,
		});
	}

	public async get(id: number): Promise<AxiosResponse<ImportProjectItemDTO>> {
		return this.clientService.get(`${this.prefix}/${id}`);
	}
}
